<ng-content></ng-content>
<a (click)="remove.emit()" class="bi bi-x-circle remove"></a>
